import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { BookingStore, COMMERCIAL_BOOKING_TABS, InstallationsStore } from '@store';
import { SubscriptionPlan } from '@vi-iot/client';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-commercial-booking',
  templateUrl: './commercial-booking.component.html',
  styleUrls: ['./commercial-booking.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommercialBookingComponent implements OnInit, OnDestroy {
  @ViewChild('stepper', { static: false }) stepper: MatStepper;

  currentStep = COMMERCIAL_BOOKING_TABS.SELECT_PLAN;
  selectedPlan: SubscriptionPlan;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public installationsStore: InstallationsStore,
    private bookingStore: BookingStore,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.bookingStore.resetUserSelection();
    this.bookingStore.loadInstallations();
    this.bookingStore.loadBookingInstallation();
    this.bookingStore.getAllVitoguideSubscriptions();

    this.bookingStore.selectedPlan$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((plan) => {
      if (this.selectedPlan && !plan) {
        this.stepper.reset();
        this.cdRef.detectChanges();
      }
      this.selectedPlan = plan;
    });
  }

  nextStep(stepper: MatStepper): void {
    stepper.selected.completed = true;
    stepper.next();
  }

  previousStep(stepper: MatStepper): void {
    stepper.selected.completed = false;
    stepper.previous();
  }

  initialStep(stepper: MatStepper): void {
    stepper.reset();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
